import { IPrivateAPI } from './types';
import { IApiHostConfig } from './limitPrivateAPI/common';
import { buildLimitedPrivateApi } from './limitPrivateAPI';

export class LimitedPrivateAPI {
  constructor(private privateAPI: IPrivateAPI) {}

  build(config: IApiHostConfig) {
    return buildLimitedPrivateApi(this.privateAPI, config);
  }
}
